export default "__VITE_ASSET__DzJwCC9I__"